import { disease, researchGroup } from '@stereoagency/sanity-schema';

const researchGroupQuery = researchGroup.schema.builder
  .filter('_id in ^.linkedResearchContent[]._ref')
  .pick(['_id', 'slug', 'title'])
  .map((resolver) => ({
    researchGroupLeader: resolver.researchGroupLeader
      .resolve(['_id', 'name', 'firstName', 'image'])
      .use()
  }))
  .use();

export const diseasesQuery = disease.schema.builder
  .pick(['_id', 'name', 'content'])
  .subquery({
    researchGroups: researchGroupQuery
  })
  .use();
